import { render, staticRenderFns } from "./visit-image-table.vue?vue&type=template&id=7363c481&scoped=true&"
import script from "./visit-image-table.vue?vue&type=script&lang=js&"
export * from "./visit-image-table.vue?vue&type=script&lang=js&"
import style0 from "./visit-image-table.vue?vue&type=style&index=0&id=7363c481&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7363c481",
  null
  
)

export default component.exports